import { useCallback, useContext } from 'react';
import { DealRoom } from 'models/DealRoom';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

export default function useShowGetBuyers() {
  const { isSuperAdmin, currentUser } = useContext(CurrentUserContext);

  return useCallback(
    (deal: Partial<DealRoom>) =>
      !isSuperAdmin &&
      !currentUser?.snoozedDealRoomBannerNotification &&
      deal?.showGetBuyersBanner,
    [isSuperAdmin, currentUser],
  );
}
